import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { MyDayClient, myDayApiRef } from './api';

/** @public */
export const myDayPlugin = createPlugin({
  id: 'my-day',
  apis: [
    createApiFactory({
      api: myDayApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new MyDayClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/**
 * Home page card answering "what needs my attention today?": pull requests to
 * review, the user's own pull requests, failed pipelines, security alerts on
 * their teams' repositories, doc feedback and ServiceNow tickets.
 *
 * @public
 */
export const MyDayCard = myDayPlugin.provide(
  createComponentExtension({
    name: 'MyDayCard',
    component: {
      lazy: () => import('./components/MyDayCard').then(m => m.MyDayCard),
    },
  }),
);
